// Deeplinks a los webmails más usados de la base (top-20 real de prod
// 2026-07-12: gmail 80.4%, familia Microsoft ~14%, yahoo ~2.4%, icloud 0.9%).
// Objetivo: que el usuario encuentre el mail de verificación aunque Gmail lo
// haya mandado a Spam o Promociones.
//
// Gmail soporta búsqueda por URL: si VITE_SENDER_EMAIL está seteado al build
// (remitente por entorno, ej no-reply@lpfplay.com), el link abre directamente
// la búsqueda `in:anywhere from:<remitente>` — que incluye Spam. Los demás
// proveedores no tienen búsqueda por URL estable: van al inbox.

const SENDER = (import.meta.env['VITE_SENDER_EMAIL'] as string | undefined)?.trim();

interface WebmailProvider {
  label: string;
  domains: readonly string[];
  url: () => string;
}

const PROVIDERS: readonly WebmailProvider[] = [
  {
    label: 'Gmail',
    domains: ['gmail.com', 'googlemail.com'],
    url: () =>
      SENDER
        ? `https://mail.google.com/mail/u/0/#search/${encodeURIComponent(`in:anywhere from:${SENDER}`)}`
        : 'https://mail.google.com/mail/u/0/',
  },
  {
    label: 'Outlook',
    domains: [
      'hotmail.com',
      'hotmail.com.ar',
      'hotmail.es',
      'outlook.com',
      'outlook.com.ar',
      'outlook.es',
      'live.com',
      'live.com.ar',
      'msn.com',
    ],
    url: () => 'https://outlook.live.com/mail/0/',
  },
  {
    label: 'Yahoo Mail',
    domains: ['yahoo.com', 'yahoo.com.ar', 'yahoo.es'],
    url: () => 'https://mail.yahoo.com/',
  },
  {
    label: 'iCloud Mail',
    domains: ['icloud.com', 'me.com', 'mac.com'],
    url: () => 'https://www.icloud.com/mail/',
  },
];

export interface WebmailLink {
  /** Nombre del proveedor, para el CTA ("Abrir Gmail"). */
  label: string;
  url: string;
}

/** Deeplink al webmail del dominio del email, o null si no es un proveedor conocido. */
export function webmailLink(email: string): WebmailLink | null {
  const at = email.trim().toLowerCase().lastIndexOf('@');
  if (at < 0) return null;
  const domain = email.trim().toLowerCase().slice(at + 1);
  const provider = PROVIDERS.find((p) => p.domains.includes(domain));
  return provider ? { label: provider.label, url: provider.url() } : null;
}
